'use client';

import React from 'react';
import SectionHeader from '@/components/molecules/section-header';
import Tabs from '@/components/organisms/tabs';
import Accordion from '@/components/molecules/accordion';
import RichTextContentBlock from '@/components/organisms/rich-text-content-block';
import { groupFaqItems } from './utils/groupFaqItems';
import { FaqSectionProps } from './types';

const FaqSection = ({ eyebrow, heading, intro, items }: FaqSectionProps) => {
  const categories = groupFaqItems(items);

  if (!categories.length) return null;

  return (
    <section className="px-4 py-12 md:px-6 md:py-16 lg:px-12 lg:py-20">
      <div className="mx-auto max-w-4xl">
        <SectionHeader variant="centered" eyebrow={eyebrow} title={heading} intro={intro} />

        <Tabs defaultActiveIndex={0}>
          <Tabs.TabList variant="pill">
            {categories.map(({ category }) => (
              <Tabs.Tab key={category}>{category}</Tabs.Tab>
            ))}
          </Tabs.TabList>

          <Tabs.Panels>
            {categories.map(({ category, items: panelItems }) => (
              <Tabs.Panel key={category}>
                <div className="space-y-2">
                  {panelItems.map((item, index) => (
                    <Accordion key={`${category}-${index}`}>
                      <Accordion.Button defaultSpacing={false} className="px-4 py-[18px] md:px-6 lg:px-8">
                        <span className="text-16 md:text-18 text-primary font-semibold">{item.question}</span>
                      </Accordion.Button>
                      {/* Panel owns only the bottom padding; the answer's left edge aligns with the
                          question via RichTextContentBlock's own px-4 md:px-6 lg:px-8 wrapper. */}
                      <Accordion.Panel defaultSpacing={false} className="pb-6">
                        <RichTextContentBlock
                          content={item.answer}
                          verticalSpacing="none"
                          containerWidth="full"
                          proseSize="sm"
                        />
                      </Accordion.Panel>
                    </Accordion>
                  ))}
                </div>
              </Tabs.Panel>
            ))}
          </Tabs.Panels>
        </Tabs>
      </div>
    </section>
  );
};

export default FaqSection;
